import { Component } from '@angular/core';
import {ViewController} from "ionic-angular";
import {LoadingServiceProvider} from "../../providers/loading-service/loading-service";

/**
 * Generated class for the DeleteFotoPopoverComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'delete-foto-popover',
  templateUrl: 'delete-foto-popover.html'
})
export class DeleteFotoPopoverComponent {
  constructor(public viewCtrl: ViewController, private loadingController: LoadingServiceProvider) {}

  public delete(toDelete) {
    this.loadingController.present();
    this.viewCtrl.dismiss(toDelete);
  }
}



// WEBPACK FOOTER //
// ./src/components/delete-foto-popover/delete-foto-popover.ts